import React from 'react';
import { CardBody, CardTitle, Form, FormGroup, Label, Input } from 'reactstrap';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

const propTypes = {
  websiteURL: PropTypes.string,
  videoURL: PropTypes.string,
  setWebsiteURL: PropTypes.func,
  setVideoURL: PropTypes.func,
};

const defaultProps = {
  websiteURL: '',
  videoURL: '',
  setWebsiteURL: undefined,
  setVideoURL: undefined,
};

const Additional = (props) => {
  const {
    websiteURL, videoURL, setWebsiteURL, setVideoURL,
  } = props;

  return (
    <div style={{ backgroundColor: '#f6f6f6' }}>
      <CardBody>
        <CardTitle>Additional Info</CardTitle>
        <Form>
          <FormGroup>
            <Label>Category</Label>
            <Input bsSize="lg" value={websiteURL} onChange={e => setWebsiteURL(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Website URL</Label>
            <Input bsSize="lg" value={websiteURL} onChange={e => setWebsiteURL(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Video URL</Label>
            <Input bsSize="lg" value={videoURL} onChange={e => setVideoURL(e.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label>Logo Image</Label>
            <Dropzone style={{ width: 400, height: 400 }} />
          </FormGroup>
          <FormGroup>
            <Label>Cover Photo</Label>
            <Dropzone />
          </FormGroup>
        </Form>
      </CardBody>
    </div>
  );
};

Additional.propTypes = propTypes;
Additional.defaultProps = defaultProps;

export { Additional };



// WEBPACK FOOTER //
// ./src/business/register/components/additional.js